import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import toast from "react-hot-toast";

const total = Math.floor(Math.random() * 50) + 10;
const sold = Math.floor(Math.random() * total);
const percent = Math.round((sold / total) * 100);

const PromotionalTwo = () => {
  const [products, setProducts] = useState([]);
  const navigate = useNavigate();

  // ✅ Fetch Ink, Toner & Paper Supplies products
  useEffect(() => {
    fetch("/assets/data/products.json")
      .then((res) => res.json())
      .then((data) => {
        const filtered = data.filter(
          (item) =>
            item.category &&
            item.category.toLowerCase().includes("ink-toner-paper")
        );
        setProducts(filtered);
      })
      .catch((err) => console.error("Error loading products:", err));
  }, []);

  // ✅ Add to Cart Handler (same logic as main)
  const handleAddToCart = (product) => {
    const isLoggedIn = sessionStorage.getItem("isLoggedIn");

    if (isLoggedIn !== "true") {
      toast.error("Please login first!");
      navigate("/login");
      return;
    }

    // Retrieve existing cart or create new one
    let cart = JSON.parse(sessionStorage.getItem("cart")) || [];

    // Check if product already exists
    const existing = cart.find((item) => item.id === product.id);

    if (existing) {
      existing.quantity += 1;
    } else {
      cart.push({ ...product, quantity: 1 });
    }

    sessionStorage.setItem("cart", JSON.stringify(cart));
    toast.success(`${product.name} added to cart!`);
  };

  return (
    <section className="offer sec-blue">
      <div className="container container-lg">
        <div style={{ padding: "80px" }}>
          <h4 className="text-center text-white">
            Premium Ink Cartridges & Supplies
          </h4>
          <p className="text-center text-white" style={{ fontSize: "16px" }}>
            Your printer deserves the best. At Printing Dealz, we offer
            high-quality ink, smooth-feeding paper, and trusted supplies that
            keep your printer running flawlessly. Enjoy consistent performance,
            clear prints, and long-lasting reliability while protecting your
            machine and warranty.
          </p>

          <div className="row gy-4 mt-40 mb-30">
            {[
              {
                icon: "ph-fill ph-lightning",
                title: "Authentic Quality",
                text: "Original cartridges ensure premium printing.",
              },
              {
                icon: "ph-fill ph-currency-circle-dollar",
                title: "High Yield Options",
                text: "XL cartridges last longer, saving money.",
              },
              {
                icon: "ph-fill ph-truck",
                title: "Fast Delivery",
                text: "Swift shipping keeps your supplies stocked.",
              },
            ].map((item, index) => (
              <div className="col-xxl-4 col-sm-6" key={index}>
                <div
                  className="d-flex align-items-center rounded-4"
                  style={{
                    background:
                      "linear-gradient(135deg, #2234a0 0%, #3b4cc0 100%)",
                    color: "#fff",
                    borderRadius: "16px",
                    boxShadow: "0 6px 18px rgba(0,0,0,0.1)",
                    transition: "all 0.3s ease",
                    cursor: "pointer",
                    padding: "30px 28px", // ✅ spacing inside box
                    gap: "16px", // ✅ gap between icon & text
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = "translateY(-5px)";
                    e.currentTarget.style.boxShadow =
                      "0 10px 25px rgba(0,0,0,0.2)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "translateY(0)";
                    e.currentTarget.style.boxShadow =
                      "0 6px 18px rgba(0,0,0,0.1)";
                  }}
                >
                  {/* 🔹 Icon Circle */}
                  <div
                    className="d-flex justify-content-center align-items-center"
                    style={{
                      width: "64px",
                      height: "64px",
                      borderRadius: "50%",
                      backgroundColor: "rgba(255, 255, 255, 0.15)",
                      flexShrink: 0,
                    }}
                  >
                    <i
                      className={item.icon}
                      style={{ fontSize: "30px", color: "#fff" }}
                    />
                  </div>

                  {/* 🔹 Text Content */}
                  <div>
                    <h6
                      style={{
                        marginBottom: "8px",
                        fontWeight: "600",
                        fontSize: "18px",
                        color: "#fff",
                      }}
                    >
                      {item.title}
                    </h6>
                    <p
                      style={{
                        margin: 0,
                        fontSize: "14px",
                        color: "rgba(255,255,255,0.85)",
                        lineHeight: "1.6",
                      }}
                    >
                      {item.text}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="row gy-4" style={{ marginTop: "50px" }}>
            {products.map((item) => {
              const total = Math.floor(Math.random() * 50) + 10;
              const sold = Math.floor(Math.random() * total);
              const percent = Math.round((sold / total) * 100);
              const rating = (Math.random() * 1 + 4).toFixed(1);
              const reviews = Math.floor(Math.random() * 9000) + 1000;

              return (
                <div className="col-sm-3" key={item.id}>
                  <div
                    className="rounded-16 bg-white shadow-sm position-relative overflow-hidden transition-3"
                    style={{
                      border: "1px solid #e3e6ed",
                      padding: "20px",
                      transition: "all 0.3s ease",
                      height: "480px",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = "translateY(-6px)";
                      e.currentTarget.style.boxShadow =
                        "0 10px 25px rgba(0, 0, 0, 0.15)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = "translateY(0)";
                      e.currentTarget.style.boxShadow =
                        "0 4px 12px rgba(0,0,0,0.08)";
                    }}
                  >
                    {/* 🔹 Product Image */}
                    <Link
                      to={`/product/${item.id}`}
                      className="d-flex justify-content-center align-items-center rounded-8 position-relative"
                      style={{
                        height: "200px",
                        marginBottom: "15px",
                      }}
                    >
                      <img
                        src={
                          item.imageUrl ||
                          "assets/images/thumbs/product-two-img1.png"
                        }
                        alt={item.name}
                        style={{
                          maxWidth: "160px",
                          maxHeight: "160px",
                          objectFit: "contain",
                        }}
                      />
                    </Link>

                    {/* 🔹 Rating */}
                    <div className="d-flex align-items-center gap-1 mb-2">
                      <i
                        className="ph-fill ph-star"
                        style={{ color: "#FFD700", fontSize: "16px" }}
                      ></i>
                      <span className="text-sm text-gray-600">
                        {rating} ({reviews.toLocaleString()})
                      </span>
                    </div>

                    {/* 🔹 Product Title */}
                    <h6
                      style={{
                        fontSize: "16px",
                        fontWeight: "600",
                        color: "#1a237e",
                        marginBottom: "6px",
                        lineHeight: "1.4",
                        height: "42px",
                        overflow: "hidden",
                      }}
                    >
                      <Link
                        to={`/product/${item.id}`}
                        className="text-decoration-none"
                      >
                        {item.name}
                      </Link>
                    </h6>

                    {/* 🔹 Brand */}
                    <div className="d-flex align-items-center gap-2 mb-2">
                      <i className="ph-fill ph-storefront text-secondary"></i>
                      <span className="text-xs text-gray-500">
                        By Printing Dealz
                      </span>
                    </div>

                    {/* 🔹 Progress Bar */}
                    <div className="my-2">
                      <div
                        className="progress rounded-pill"
                        style={{
                          height: "5px",
                          background: "#e5e8f0",
                        }}
                      >
                        <div
                          className="progress-bar"
                          style={{
                            width: `${percent}%`,
                            background: "#1a237e",
                            borderRadius: "10px",
                          }}
                        ></div>
                      </div>
                      <small className="text-gray-600">
                        Sold: {sold}/{total}
                      </small>
                    </div>

                    {/* 🔹 Price */}
                    <div
                      className="d-flex align-items-center justify-content-between mt-3 mb-3"
                      style={{ fontSize: "15px" }}
                    >
                      {item.oldPrice && (
                        <span className="text-muted text-decoration-line-through">
                          ${item.oldPrice}
                        </span>
                      )}
                      <span className="fw-semibold text-dark">
                        ${item.price}
                        <span className="text-muted fw-normal"> /Qty</span>
                      </span>
                    </div>

                    {/* Footer Gradient Bar */}
                    <div
                      style={{
                        position: "absolute",
                        bottom: "0",
                        left: "0",
                        width: "100%",
                        background: "#3446b8",
                        color: "#fff",
                        padding: "12px 20px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        borderBottomLeftRadius: "18px",
                        borderBottomRightRadius: "18px",
                      }}
                      className="mt-40"
                    >
                      <button
                        onClick={() => {
                          handleAddToCart(item);
                          window.location.reload();
                        }}
                        type="button"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          gap: "10px",
                          border: "none",
                          color: "#fff",
                          fontWeight: "600",
                          borderRadius: "50px",
                          padding: "10px 20px",
                          cursor: "pointer",
                          transition: "all 0.3s ease",
                          width: "100%",
                          background: "transparent",
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.transform = "translateY(-2px)";
                          e.currentTarget.style.boxShadow =
                            "0 4px 10px rgba(0,0,0,0.2)";
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.transform = "translateY(0)";
                          e.currentTarget.style.boxShadow = "none";
                        }}
                      >
                        <span style={{ fontWeight: "600" }}>Add To Cart</span>
                        <span>
                          <i
                            className="ph ph-shopping-cart"
                            style={{ fontSize: "18px" }}
                          />
                        </span>
                      </button>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default PromotionalTwo;
